import { Address } from "../Address";
import { BaseRecord } from "../BaseRecord";

export class CreateB2CClient extends BaseRecord<number> {
    // user info
    userId!: number;
    firstName: string;
    lastName: string;
    email: string;
    phone!: string;
    password: string;

    // Tenant table
    tenantId!: number;
    tenantName: string;
    logoUrl: string;
    logoBase64: string;
    description: string;
    isMainTenant: boolean;

    // Client name
    clientId!: number;
    clientName: string;

    address: Address;
    isActive: boolean;

    constructor() {
        super();
        this.id = 0;
        this.userId = 0;
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.phone = "";
        this.password = "";

        this.tenantId = 0;
        this.tenantName = "";
        this.logoUrl = "";
        this.logoBase64 = "";
        this.description = "";
        this.isMainTenant = false;

        this.clientId = 0;
        this.clientName = "";

        this.address = new Address();
        this.isActive = true;
    }
}
